import { Typography } from "@mui/material";

const CustomTypography = (props: any) => {
  return (
    <>
      <Typography {...props} className={props.className} />
    </>
  );
};

export default CustomTypography;
